
import { defineComponent } from 'vue'
import LayoutNotConnected from '@/layouts/NotConnected.vue'

export default defineComponent({
  components: {
    LayoutNotConnected
  }
})
